import * as React from "react"
import { Block, generateBlock } from "./block_renderer"
import { ApiResult } from "../../../Shared/api/apiTypes"

export type AsyncBlockProps<D> = {
  kind: "async_block"
  promise: () => Promise<ApiResult<D>>
  block: (data: D) => Block 
}

export type AsyncBlockState<D> = {
  data: ApiResult<D>
}

export class AsyncBlock<D, B> extends React.Component<AsyncBlockProps<D>, AsyncBlockState<D>> {

  constructor(props: AsyncBlockProps<D>) {
    super(props)

    this.state = { 
      data: "loading"
    }
  }

  componentDidMount() {
    this.props.promise().then(data => this.setState({ data }))
  }

  render() {
    return (
      this.state.data != "loading" && this.state.data != 'error'
        ? generateBlock(this.props.block(this.state.data))
        : null
    )
  }
  
}